import { EUnitOfMeasure } from '../shared/enum';
import {
    TFlowVelocityAtThePropeller,
    TOpenPiledQuayScenario,
    TPropellerAxisParallelScenario,
    TPropellerAxisTransverseToSlopedScenario,
    TPropellerAxisTransverseToVerticalScenario,
} from '../shared/iResult';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

//FlowVelocityAtThePropeller
export const underKeelClearance: TFlowVelocityAtThePropeller = 'underKeelClearance';
export const isOkUnderKeelClearance: TFlowVelocityAtThePropeller = 'isOkUnderKeelClearance';
export const verticalDistanceBetweenThrusterAxisAndBedLevelHt: TFlowVelocityAtThePropeller = 'verticalDistanceBetweenThrusterAxisAndBedLevelHt';
export const hpYp: TFlowVelocityAtThePropeller = 'hpYp';
export const powerUnitCoefficient: TFlowVelocityAtThePropeller = 'powerUnitCoefficient';
export const flowAxialVelocity: TFlowVelocityAtThePropeller = 'flowAxialVelocity';

export const flowVelocityAtThePropellerPhysicalData = {
    [underKeelClearance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [isOkUnderKeelClearance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [verticalDistanceBetweenThrusterAxisAndBedLevelHt]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [hpYp]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [powerUnitCoefficient]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [flowAxialVelocity]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feetPerSecond,
        },
    },
};

//PropellerAxisParallelScenario
export const flowVelocityAtTheBottomVb: TPropellerAxisParallelScenario | TPropellerAxisTransverseToVerticalScenario = 'flowVelocityAtTheBottomVb';
export const minimumRevetmentWidthBProtection: TPropellerAxisParallelScenario = 'minimumRevetmentWidthBProtection';
export const isOkMinimumRevetmentWidthBProtection: TPropellerAxisParallelScenario = 'isOkMinimumRevetmentWidthBProtection';
export const minimumRevetmentThickness: TPropellerAxisParallelScenario | TPropellerAxisTransverseToVerticalScenario | TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario =
    'minimumRevetmentThickness';
export const isOkMinimumRevetmentThickness: TPropellerAxisParallelScenario | TPropellerAxisTransverseToVerticalScenario | TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario =
    'isOkMinimumRevetmentThickness';

export const propellerAxisParallelScenarioPhysicalData = {
    [flowVelocityAtTheBottomVb]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feetPerSecond,
        },
    },
    [isOkUnderKeelClearance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [minimumRevetmentWidthBProtection]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [minimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [isOkMinimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isOkMinimumRevetmentWidthBProtection]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

//PropellerAxisTransverseToVerticalScenario
export const ratioLHt: TPropellerAxisTransverseToVerticalScenario = 'ratioLHt';

export const propellerAxisTransverseToVerticalScenarioPhysicalData = {
    [isOkUnderKeelClearance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [ratioLHt]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isOkMinimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [flowVelocityAtTheBottomVb]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feetPerSecond,
        },
    },
    [minimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
};

//PropellerAxisTransverseToSlopedScenario
export const horizontalDistanceBetweenPropellerAxisAndTheSlope: TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario = 'horizontalDistanceBetweenPropellerAxisAndTheSlope';
export const k: TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario = 'k';
export const slopeAbscissaOfMaximumCurrentVelocityXvMax: TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario = 'slopeAbscissaOfMaximumCurrentVelocityXvMax';
export const vSlopeMax: TPropellerAxisTransverseToSlopedScenario | TOpenPiledQuayScenario = 'vSlopeMax';

export const propellerAxisTransverseToSlopedScenarioPhysicalData = {
    [isOkUnderKeelClearance]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [horizontalDistanceBetweenPropellerAxisAndTheSlope]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [k]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [slopeAbscissaOfMaximumCurrentVelocityXvMax]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [vSlopeMax]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [isOkMinimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [minimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
};

//OpenPiledQuayScenario
export const pilesInfluenceCoefficient: TOpenPiledQuayScenario = 'pilesInfluenceCoefficient';
export const vSlPilesMax: TOpenPiledQuayScenario = 'vSlPilesMax';

export const openPiledQuayScenarioPhysicalData = {
    [horizontalDistanceBetweenPropellerAxisAndTheSlope]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feet,
        },
    },
    [k]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [slopeAbscissaOfMaximumCurrentVelocityXvMax]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [vSlopeMax]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [minimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [pilesInfluenceCoefficient]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [vSlPilesMax]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meterPerSecond,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.feetPerSecond,
        },
    },
    [isOkMinimumRevetmentThickness]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
};

export const resultPhysicalData = {
    ...openPiledQuayScenarioPhysicalData,
    ...propellerAxisTransverseToSlopedScenarioPhysicalData,
    ...propellerAxisTransverseToVerticalScenarioPhysicalData,
    ...propellerAxisParallelScenarioPhysicalData,
    ...flowVelocityAtThePropellerPhysicalData,
};

export type TResultPhysicalData =
    | TFlowVelocityAtThePropeller
    | TPropellerAxisTransverseToVerticalScenario
    | TPropellerAxisTransverseToSlopedScenario
    | TOpenPiledQuayScenario
    | TPropellerAxisParallelScenario;
